// Native details remains usable without JavaScript. Animation is confined to
// this section so Product Information's accordion behavior stays independent.
class PebbleFaqBanner extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    // The drawer changes the section width without changing the viewport.
    // Match the same content-box breakpoint as CSS; retain picture's media
    // fallback when JavaScript is unavailable and avoid fetching two images.
    this.imageObserver?.disconnect();
    const source = this.querySelector('picture source');
    if (source && this.parentElement) {
      this.imageObserver = new ResizeObserver(([entry]) => {
        const media = entry.contentRect.width <= 700 ? 'all' : 'not all';
        if (source.media !== media) source.media = media;
      });
      this.imageObserver.observe(this.parentElement);
    }
    this.addEventListener('click', (event) => {
      const summary = event.target.closest('summary');
      if (!summary || !this.contains(summary)) return;
      event.preventDefault();
      const item = summary.parentElement;
      const opening = !(item.dataset.targetOpen === 'true' || (item.open && item.dataset.targetOpen !== 'false'));
      if (opening && this.dataset.single === 'true') {
        this.querySelectorAll('details[open]').forEach(other => { if (other !== item) this.toggleItem(other, false); });
      }
      this.toggleItem(item, opening);
    }, { signal: this.abort.signal });
    document.addEventListener('shopify:block:select', event => {
      const item = event.target.closest('.pebble-faq-banner__item');
      if (item && this.contains(item)) this.toggleItem(item, true);
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); this.imageObserver?.disconnect(); }
  toggleItem(item, opening) {
    const start = item.getBoundingClientRect().height;
    item._faqAnimation?.cancel();
    item.dataset.targetOpen = String(opening);
    item.open = true;
    let end = item.scrollHeight;
    if (!opening) {
      item.open = false;
      end = item.getBoundingClientRect().height;
      item.open = true;
    }
    const finish = () => { item.open = opening; delete item.dataset.targetOpen; item._faqAnimation = null; };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
    const animation = item.animate({ height: [`${start}px`, `${end}px`] }, {
      duration: opening ? 280 : 250, easing: opening ? 'cubic-bezier(.22,1,.36,1)' : 'ease-in-out'
    });
    item._faqAnimation = animation;
    animation.onfinish = finish;
  }
}
if (!customElements.get('pebble-faq-banner')) customElements.define('pebble-faq-banner', PebbleFaqBanner);
